import React, { useState, useContext, useCallback } from 'react';
import { IParameterContext } from './ParameterProvider.types';
import { EhpcMessage } from '../../Common';
import uuidv4 from 'uuid/v4';
import { ParameterFormValues } from '../ParameterForm.types';

export const ParameterContext = React.createContext<IParameterContext>({
  filter: undefined,
  setFilter: (): void => {
    throw new Error();
  },
  getFilter: (): ParameterFormValues | undefined => {
    throw new Error();
  },
  resetForm: undefined,
  setResetForm: (): void => {
    throw new Error();
  },
  messages: [],
  setMessage: (): void =>  {
    throw new Error();
  },
  removeMessage: (): void => {
    throw new Error();
  }
});

export const ParameterConsumer = ParameterContext.Consumer;
/**
 * https://www.taniarascia.com/using-context-api-in-react/
 * @param param0
 */
export const ParameterProvider: React.FC = ({ children }) => {
  const [ filter, setFilter ] = useState<IParameterContext['filter']>(undefined);
  const [ resetDate, setResetDate ] = useState<IParameterContext['resetForm']>(undefined);
  const [ messages, setMessage ] = useState<IParameterContext['messages']>([]);

  const setFilterIntern = useCallback((filterIntern: any) => {
    setFilter(filterIntern);
  }, []);

  const setMessageIntern = useCallback((m: EhpcMessage) => {
    if (m.id=== undefined) m.id = uuidv4();
    setMessage(mlist => [...mlist, m]);
  },[]);

  const removeMessageIntern = useCallback((m: EhpcMessage) => {
    setMessage((list: EhpcMessage[]) => {

      list.forEach(i => {
        if(i.id === m.id) {
          list.splice(list.indexOf(i),1);
        }
      });
      return [...list]; 
    });
  },[]);

  const parametersContext: IParameterContext = {
    filter: filter,
    setFilter: setFilterIntern,
    getFilter: () => {
      return filter;
    },
    resetForm: resetDate,
    setResetForm: () => {
      setResetDate(new Date());
    },
    messages,
    setMessage: setMessageIntern,
    removeMessage: removeMessageIntern,
  }

  return (
    <ParameterContext.Provider value={parametersContext}>
      {children}
    </ParameterContext.Provider>
  );

}

export const useParameterContext = () => useContext(ParameterContext);
